module.exports = __webpack_public_path__ + "img/ilustra5.9d1061e5.png";